import React, { useContext, useEffect } from 'react';
import ModalItem from '../../common/ModalItem/ModalItem';
import Container from '@material-ui/core/Container';
import { useTranslation } from 'react-i18next';
import './my-activity.scss';
import { changeErrorPopupState } from '../../../store/uiSlice';
import { getActivities } from '../../../store/activitiesSlice';
import { connect } from 'react-redux';
import ActivityItem from './activityItem';
import { Route, Switch, useHistory } from 'react-router-dom';
import TaskFinish from '../TaskFinish/TaskFinish';
import Dispute from '../Dispute/Dispute';
import { completedRoutes } from '../../../common/constants';
import { Hidden } from '@material-ui/core';
import IsMobileContext from '../../../common/IsMobileContext';
import { getUserBalance } from '../../../store/userSlice';
import ScoreToRubblesInfo from '../../common/ScroreToRubbleInfo';

const ContentSwitch = (props) => {
  const { desktopOption, content } = props;
  return (
    <Switch>
      <Route exact path={completedRoutes.userActivitySolution}>
        <TaskFinish />
      </Route>
      <Route path={completedRoutes.userActivityDispute}>
        <Dispute />
      </Route>
      {desktopOption &&
      <Route>
        {content}
      </Route>
      }
    </Switch>
  );
};

function MyActivity(props) {
  const { t } = useTranslation();
  const isMobileDesign = useContext(IsMobileContext);
  const history = useHistory();
  const {
    getActivities, activities, fetchingState, changeErrorPopupState,
    getUserBalance,
  } = props;

  useEffect(() => {
    const fetchData = () => {
      Promise.all([getActivities(), getUserBalance()])
        .catch((error) => {
          if (error.status === 401) {
            history.replace(
              completedRoutes.signUpModalItem,
              { currentUrl: completedRoutes.userActivity, goBackUrl: completedRoutes.userTasks },
            );
          } else {
            console.error(error);
            changeErrorPopupState({ type: 'default', error, isOpen: true });
          }
        })
    };
    fetchData();
  }, [getActivities, changeErrorPopupState, getUserBalance, history]);

  const isLoading = (
    fetchingState === 'requesting' ||
    fetchingState === 'none'
  );

  const isError = fetchingState === 'failed';

  const content = (
    <Container className="my-activity-container">
      <h2>
        {t('activities.myActivities')}
        <div><ScoreToRubblesInfo /></div>
      </h2>
      <div className="content">
        {fetchingState === 'success' && activities.length === 0 && (
          <p>{t('activities.activitiesEmpty')}</p>
        )}
        {!isLoading && !isError && activities.map((i) => {
          return <ActivityItem item={i} key={i.id} />
        })}
      </div>
    </Container>
  );

  return (
    <ModalItem>
      <>
        <Hidden mdUp>
          {content}
        </Hidden>
        <ContentSwitch desktopOption={!isMobileDesign} content={content} />
      </>
    </ModalItem>
  );
}

const mapStateToProps = state => ({
  activities: state.activities.data,
  fetchingState: state.activities.fetchingState,
});

const actionCreators = {
  changeErrorPopupState: changeErrorPopupState,
  getActivities,
  getUserBalance,
};

export default connect(mapStateToProps, actionCreators)(MyActivity);
